import { RouterProvider } from "@tanstack/react-router";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { AuthProvider } from "./auth/AuthProvider";

import { router } from "./router";
import "./styles.css";

registerSW({
  immediate: true,
  onRegisteredSW: (_serviceWorkerUrl, registration) => {
    if (registration) {
      void registration.update().catch(() => undefined);
    }
  },
});

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

document.querySelector("title[data-spa-title-fallback]")?.remove();

createRoot(rootElement).render(
  <AuthProvider>
    <RouterProvider router={router} />
  </AuthProvider>,
);
